<ph-stack gap="snug" align="start">
    <ph-file-upload *ngIf="showDropZone; else preview"
                    [accept]="accept"
                    [hint]="hint"
                    [disabled]="busy"
                    (ph-files)="onFiles($event)"></ph-file-upload>

    <ng-template #preview>
        <ng-container *ngIf="avatar; else thumbnail">
            <ph-avatar *ngIf="src || fallbackSrc; else avatarPlaceholder"
                       [size]="avatarSize"
                       [src]="src || fallbackSrc"
                       [alt]="alt"></ph-avatar>
            <ng-template #avatarPlaceholder>
                <ph-avatar [size]="avatarSize" [placeholder]="placeholder || 'user'"></ph-avatar>
            </ng-template>
        </ng-container>
        <ng-template #thumbnail>
            <ph-file-thumbnail *ngIf="src; else fallbackThumbnail"
                               [src]="src"
                               [alt]="alt"
                               [shape]="shape"
                               [size]="size"
                               [removeLabel]="removeLabel"
                               [noRemove]="!removable || busy"
                               (ph-remove)="remove()"></ph-file-thumbnail>
            <ng-template #fallbackThumbnail>
                <ph-file-thumbnail *ngIf="fallbackSrc || placeholder"
                                   [src]="fallbackSrc"
                                   [placeholder]="placeholder"
                                   [alt]="alt"
                                   [shape]="shape"
                                   [size]="size"
                                   [noRemove]="true"></ph-file-thumbnail>
            </ng-template>
        </ng-template>

        <ph-actions align="start">
            <ph-button variant="secondary"
                       mode="filled"
                       size="small"
                       type="button"
                       icon="upload-simple"
                       [disabled]="disabled"
                       [loading]="saving"
                       (click)="picker.click()">{{ src ? changeLabel : buttonLabel }}</ph-button>
            <ph-button *ngIf="src && removable && avatar"
                       variant="error"
                       mode="stroke"
                       size="small"
                       type="button"
                       icon="trash"
                       [disabled]="busy"
                       (click)="remove()">{{ removeLabel }}</ph-button>
        </ph-actions>
        <ph-hint *ngIf="hint">{{ hint }}</ph-hint>
    </ng-template>

    <ph-alert *ngIf="underSized && !shownError" status="warning" variant="lighter">{{ underSizedText }}</ph-alert>
    <ph-hint *ngIf="shownError" [hasError]="true">{{ shownError }}</ph-hint>
</ph-stack>

<input #picker type="file" hidden [accept]="accept" (change)="onPicked(picker)">
